function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M131 493.857L4.24352e-06 622L53.1524 370L131 493.857Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1208.91 233.255L934.685 296.901L971.82 164.935L1208.91 233.255Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M867.309 642.394L998.596 626.618L832.375 573.73L867.309 642.394Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M310.589 45.3812L187 78.4968L258.307 96.3261L310.589 45.3812Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 10.8091,
  y1: 659.29,
  x2: 58.8241,
  y2: 440.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42FF99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8FFD2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 924.185,
  y1: 330.476,
  x2: 1069.79,
  y2: 189.164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99FFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFF9E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 1021.52,
  y1: 639.376,
  x2: 871.784,
  y2: 640.609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#42FF99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8FFD2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 174.701,
  y1: 67.4872,
  x2: 267.214,
  y2: 89.0113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99FFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFF9E"
})));

var SvgFrontTriangles = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1209,
    height: 681,
    viewBox: "0 0 1209 681",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFrontTriangles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/front-triangles.e6e2a192.svg";
export { ForwardRef as ReactComponent };